export const _20_MB_IN_BYTES = 20 * 1024 * 1024
export const _5_MB_IN_BYTES = 5 * 1024 * 1024
